import React, { useCallback } from 'react';
import { observer } from 'mobx-react-lite';
import {
  applicationStore,
  convertAmount,
  formatDate,
  getAmountWithCurrency,
  ListBoxItemImg,
  ListElemText,
  ListItemBox,
  ListItemBoxCell,
  ListItemBoxHeader,
  ListItemBoxRow,
  ListItemBoxText,
  ListItemCont,
  popupStore,
  useTranslation,
} from '@pascal/pascal-core';

import { marketTypes } from '../../../helpers/constants';
import { globalTranslationKeys, PopupTypes } from '../../../enums';
import pfCheck from '../../../assets/images/core/pf-check.png';

export const BetHistoryItem = observer(({ bet }) => {
  const t = useTranslation();
  const { detectAndOpenCheckHashPopup, currentData } = popupStore;
  const { isDemo } = applicationStore;

  const openCheckHash = useCallback(
    ({ currentTarget }) => {
      if (!isDemo) {
        const selectedId = +currentTarget.getAttribute('name');
        detectAndOpenCheckHashPopup({
          selectedId,
          name: PopupTypes.CheckHash,
          isFromBetHistory: true,
        });
      }
    },
    [detectAndOpenCheckHashPopup, isDemo]
  );

  const { marketType, number } = bet.additionalParams;

  return (
    <ListItemCont>
      <ListItemBox
        haveHover={!isDemo}
        name={bet?.id}
        onClick={openCheckHash}
        isSelected={bet?.id === currentData?.id}
      >
        <ListItemBoxHeader>
          <ListItemBoxCell size='big'>
            <ListItemBoxText
              size='big'
              text={`${t(globalTranslationKeys.RoundId)} ${bet?.roundId}`}
            />
          </ListItemBoxCell>
          <ListItemBoxCell size='small'>
            <ListItemBoxText text={formatDate(bet?.date)} size='big' />
          </ListItemBoxCell>
          {!isDemo && (
            <ListItemBoxCell size='small'>
              <ListBoxItemImg imageSrc={pfCheck} />
            </ListItemBoxCell>
          )}
        </ListItemBoxHeader>
        <ListItemBoxRow>
          <ListItemBoxCell size='big'>
            <ListItemBoxText size='big' text={`${t(globalTranslationKeys.BetType)}`} />
          </ListItemBoxCell>
          <ListItemBoxCell>
            <ListElemText
              title={`${
                marketType === marketTypes.Under
                  ? t(globalTranslationKeys.Under)
                  : t(globalTranslationKeys.Over)
              } ${number}`}
            >
              <i
                className={`ui-lib-over-arrow-2 ${
                  marketType === marketTypes.Under ? 'under' : 'over'
                }`}
              />
              {number}
            </ListElemText>
          </ListItemBoxCell>
        </ListItemBoxRow>
        <ListItemBoxRow>
          <ListItemBoxCell size='big'>
            <ListItemBoxText size='big' text={`${t(globalTranslationKeys.Odd)}`} />
          </ListItemBoxCell>
          <ListItemBoxCell>
            <ListItemBoxText size='big' text={`x${bet?.odd}`} />
          </ListItemBoxCell>
        </ListItemBoxRow>
        <ListItemBoxRow>
          <ListItemBoxCell size='big'>
            <ListItemBoxText size='big' text={`${t(globalTranslationKeys.Bet)}`} />
          </ListItemBoxCell>
          <ListItemBoxCell>
            <ListItemBoxText
              size='big'
              text={`${
                bet?.freeBetId
                  ? `${t(globalTranslationKeys.FreeBet)} : ${getAmountWithCurrency({
                      amount: convertAmount(bet?.amount),
                    })}`
                  : `${getAmountWithCurrency({
                      amount: convertAmount(bet?.amount),
                    })}`
              }`}
            />
          </ListItemBoxCell>
        </ListItemBoxRow>
        <ListItemBoxRow>
          <ListItemBoxCell size='big'>
            <ListItemBoxText size='big' text={`${t(globalTranslationKeys.Result)}`} />
          </ListItemBoxCell>
          <ListItemBoxCell>
            <ListItemBoxText size='big' text={bet?.roundData} />
          </ListItemBoxCell>
        </ListItemBoxRow>
        <ListItemBoxRow>
          <ListItemBoxCell size='big'>
            <ListItemBoxText size='big' text={`${t(globalTranslationKeys.Win)}`} />
          </ListItemBoxCell>
          <ListItemBoxCell>
            <ListItemBoxText
              className='win-color'
              size='big'
              text={`${getAmountWithCurrency({
                amount: convertAmount(bet?.winAmount || 0),
              })}`}
            />
          </ListItemBoxCell>
        </ListItemBoxRow>
      </ListItemBox>
    </ListItemCont>
  );
});
